import { render, staticRenderFns } from "./actuals_payroll_summary_report.vue?vue&type=template&id=97034a4c&scoped=true&"
import script from "./actuals_payroll_summary_report.vue?vue&type=script&lang=js&"
export * from "./actuals_payroll_summary_report.vue?vue&type=script&lang=js&"
import style0 from "./actuals_payroll_summary_report.vue?vue&type=style&index=0&id=97034a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97034a4c",
  null
  
)

export default component.exports